/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import styled from "styled-components";
import {
  FontSizes,
  getTheme,
  ISpinnerStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

/**
 * Tokens for stack of event data elements
 */
export const eventStackTokens: IStackTokens = { childrenGap: 5 };

/**
 * Styles for stack of event data elements
 */
export const eventStackStyles: IStackStyles = {
  root: {
    marginTop: 10,
  },
};

/**
 * Styling for the data and form labels
 */
export const labelTextStyles: ITextStyles = {
  root: {
    minWidth: 200,
  },
};

/**
 * Styles for title at top of modal
 */
export const titleStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.xLarge,
    marginBottom: 20,
  },
};

/**
 * Element at top of modal to display title
 */
export const TitleContainer = styled.div`
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${theme.palette.neutralLight};
`;

/**
 * Styles for section within the detail (to separate sections of event data)
 */
export const sectionTitleStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.large,
    paddingTop: 20,
  },
};

/**
 * Styles for the loading spinner
 */
export const spinnerStyles: ISpinnerStyles = {
  root: {
    marginTop: 32,
  },
};
